import {AppState} from '../../index';

export interface OfferLunGeoData {
  year?: number;
  ceilHeight?: number;
  floorCnt?: number;
  houseType?: number;
  houseProjectType?: number;
  wallType?: number;
}

const OFFERS_LUN_GEO_DATA = '@offers/lun-geo-data';

export interface OfferLunGeoAction {
  type: typeof OFFERS_LUN_GEO_DATA;
  payload: {
    data: OfferLunGeoData
  };
}

interface State {
  data: OfferLunGeoData;
}

const initialState: State = {
  data: {
    year: undefined,
    ceilHeight: undefined,
    floorCnt: undefined,
  },
};

export const offersLunGeoDataReducer = (
  state: State = initialState,
  action: OfferLunGeoAction,
) => {
  switch (action.type) {
    case OFFERS_LUN_GEO_DATA:
      return {
        ...state,
        data: action.payload.data,
      };

    default:
      return state;
  }
};

export const setOfferLunGeoData = (data: OfferLunGeoData) => {
  return {
    type: OFFERS_LUN_GEO_DATA,
    payload: {
      data,
    },
  };
};

export const getOfferLunGeoData = (state: AppState) =>
  state.offers.offerLunGeoData.data;
